import React from 'react';
import Odd from '../../common/Odd';
import { getNumberOfColsMobile } from '../../data/utils/getNumberOfColsMobile';

function Outrights(props) {
    return (
        <>
            {props.outrights.sort((a, b) => a.timestampDB - b.timestampDB).map(or => {
                return or.scommesse.map(bet => {
                    const boxUniqueId = or.id + '_' + bet.id;
                    const o = bet.odds.filter(o => o.value !== null);
                    return (
                        <ul key={boxUniqueId} id="oddslist">
                            <li className="list-element-quota show">
                                <div className="list-element">
                                    <span className="list-element-text">{or.desc} - {bet.desc}</span>
                                </div>
                                <div className={"esiti-container grid-columns-" + getNumberOfColsMobile(bet.odds.length)}>
                                    {o.map((odd, i) => {                                        
                                        return (
                                            <Odd key={i} {...odd}/>
                                        )
                                    })}
                                </div>
                            </li>
                        </ul>
                    )
                })
            })}
        </>
    )
}

export default Outrights;